export default __webpack_public_path__ + "static/media/mobile-close-icon.bcf70ab8.svg";